import { AuthService } from './AuthService';

export const authService = new AuthService();
export * from './storage';
export * from './types';
